import React, {useState} from "react";
import dropdown_arrow from "../../assets/Images/arrow_drop_down_white.svg";
import add_icon from "../../assets/Images/add.png";
import "./SubscriptionPayment.css";
interface DropdownProps<T> {
  title:string
  items: T[];
  selectedItem: T | undefined;
  onSelect: (item: T) => void;
  renderItem: (item: T, isSelected: boolean,isSelectable: boolean) => React.ReactNode;
  addButtonLabel?: string;
  onAddButtonClick?: () => void;
  isInitOpen:boolean|undefined;
  buttonColor:string|undefined;
}

  const expandArrow = (isOpen:boolean) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 24" role="img" aria-hidden="true">
    {!isOpen && 
    <g transform="rotate(180 12 12)">
      <polygon points="12,5 19,12 5,12" fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"/>
    </g>
    }
    {isOpen && 
      <polygon points="12,5 19,12 5,12" fill="currentColor" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"/>
    }
  </svg>
  );

const Dropdown = <T,>({
  title,
  items,
  selectedItem,
  onSelect,
  renderItem,
  addButtonLabel,
  onAddButtonClick,
  isInitOpen,
  buttonColor
}: DropdownProps<T>) => {
  const [isOpen, setIsOpen] = useState(isInitOpen?? false);

  return (
    <div>
      <div className="flex items-center justify-between mt-5 mx-2">
        <p className="payment-heading-list-portfolio font-poppins font-semibold">
          {title}
        </p>
        <div className="image-container"
        onClick={()=>setIsOpen(!isOpen)}
        >
          {expandArrow(isOpen)}

        </div>
      </div>

      {!isOpen && selectedItem && (
        <div className="space-y-2 mt-2">
          {renderItem(selectedItem, true,false)}
        </div>
      )}

      {isOpen && (
        <div className="space-y-2 mt-2 max-h-40 overflow-y-auto">
          {items.map((item, index) => {
            const isSelected = item === selectedItem;
            return (
              <div key={index} onClick={() => {
                onSelect(item)
                setIsOpen(false)
                }}>
                {renderItem(item, isSelected,true)}
              </div>
            );
          })}
        </div>
      )}

      {isOpen && addButtonLabel && onAddButtonClick && (
        <button
          className="custom-button-addpayment mt-3 font-poppins mx-5 mb-5"
          onClick={onAddButtonClick}
        >
          <div className="flex items-center justify-center">
          <span className="mx-2  text-2xl"
          style={{color:`${buttonColor}`}}> 
            +
          </span>
          <span className="custom-text-addpayment font-semibold"
          style={{color:`${buttonColor}`}}>
            {addButtonLabel} 
          </span>
          </div>
        </button>
      )}
    </div>
  );
};

export default Dropdown;